/**
 * Export visual theme — mirrors UI accent tokens (chromeTokens.css).
 */

import { getStoredOrgBranding } from './orgBranding';

export const ACCENT_PRIMARY_HEX = {
  teal: '0D9488',
  purple: '667EEA',
  blue: '2563EB',
  indigo: '4F46E5',
};

export const DEFAULT_ACCENT_THEME = 'teal';
export const DEFAULT_HEADER_FILL_HEX = ACCENT_PRIMARY_HEX[DEFAULT_ACCENT_THEME];

/** @returns {string} RRGGBB without '#' */
export function headerFillHexForAccent(accentTheme) {
  const key = String(accentTheme || DEFAULT_ACCENT_THEME).trim().toLowerCase();
  return ACCENT_PRIMARY_HEX[key] || DEFAULT_HEADER_FILL_HEX;
}

/**
 * Resolve CTA / table-header accent from the live DOM (org branding applied).
 * Falls back to stored branding, then default teal.
 * @returns {string} RRGGBB without '#'
 */
export function getExportHeaderFillHex() {
  try {
    const raw = getComputedStyle(document.documentElement)
      .getPropertyValue('--dp-accent-primary')
      .trim();
    const match = raw.match(/^#?([0-9a-fA-F]{6})$/);
    if (match) return match[1].toUpperCase();
  } catch {
    /* ignore */
  }

  try {
    const branding = getStoredOrgBranding();
    if (branding?.accent_theme) {
      return headerFillHexForAccent(branding.accent_theme);
    }
  } catch {
    /* ignore */
  }

  return DEFAULT_HEADER_FILL_HEX;
}

/** @param {string} hex RRGGBB or #RRGGBB */
export function hexToRgb(hex) {
  const cleaned = String(hex || '').replace('#', '').trim();
  if (!/^[0-9a-fA-F]{6}$/.test(cleaned)) {
    return { r: 13, g: 148, b: 136 }; // teal default
  }
  return {
    r: parseInt(cleaned.slice(0, 2), 16),
    g: parseInt(cleaned.slice(2, 4), 16),
    b: parseInt(cleaned.slice(4, 6), 16),
  };
}
